import Sign from "./TiacSign"

export default Sign;